export const resumeData  = {
  "home": {
    "header": {
      "name":"Neha She/Her.",
      "pronouns":"She/Her.",
      "job": "Old Dominion University",
      "image": "neha_newyork.jpg"
    },
    "social": [
      {
        "name":"github",
        "url":"https://github.com/niphadkarneha",
        "className":"fa fa-github"
      },
      {
        "name":"linkedin",
        "url":"http://linkedin.com/in/niphad",
        "className":"fa fa-skype"
      },
      {
        "name":"email",
        "url":"mailto:niphadkarneha@gmail.com",
        "className":"fa fa-skype"
      },
      {
        "name":"blog",
        "url":"/blog",
        "className":"fa fa-linkedin"
      }
    ],
    "about":[
      {
        "title" : "short",
        "class": "show",
        "content": "Hey there! I’m Neha — a Data Analytics Manager at 👩‍💻 <a href='https://www.odu.edu/digital-technology'>Old Dominion University</a> and a proud technologist in the Division of Digital Transformation and Technology. With over a decade of experience turning data into action, I build modern, insight-rich solutions that drive smarter decision-making at my alma mater.<br /><br />I’m a visual thinker at heart — passionate about tools like Tableau and Power BI — and bring a solid foundation in legacy platforms such as Logi Analytics and SAP Crystal Reports. From modernizing reporting workflows to architecting intuitive dashboards, I thrive at the intersection of data, design, governance, and impact.<br /><br />© 2022 — Built by Neha N.<br />Big thanks to the brilliant Cassidy Williams for the design inspo — and for turning mechanical keyboards into an art form! 😄"
      }
    ],
    "colors": [
      "#10a2f5",
      "#24d05a",
      "#e9bc3f",
      "#eb4888"
    ]
  },
  "blog": {
    "header":{
      "title": "Neha's Blog",
      "description": "Written by <strong>Neha N.</strong> who lives and works in Hampton Roads.",
      "avatar": "neha_newyork.jpg"
    },
    "articles":[
      {
        "title": "Reading List",
        "date": "Updated: May, 2025",
        "link": "new-beginnings",
        "short": "📚",
        "header": "Books",
        "content": `<p>A curated list of books I’ve enjoyed — from digital transformation and data ethics to poetry and fiction.</p>

        <h4>📘 Current Reads</h4>
        <ol>
          <li><a href="https://www.goodreads.com/en/book/show/55173904">Subtract: The Untapped Science of Less by Leidy Klotz</a></li>
          <li><a href="https://www.goodreads.com/book/show/613679.The_Vegetarian">The Vegetarian by Han Kang</a></li>
          <li><a href="https://www.goodreads.com/book/show/59808448-the-theory-of-karma">Theory of Karma by Dr. Anand Kulkarni</a></li>
          <li><a href="https://www.goodreads.com/book/show/44128246-data-story">DataStory: Explain Data and Inspire Action Through Story by Nancy Duarte</a></li>
          <li><a href="https://www.goodreads.com/book/show/31423262-winning-with-data">Winning with Data by Tomasz Tunguz & Frank Bien</a></li>
          <li><a href="https://www.goodreads.com/book/show/50188288-invisible-women">Invisible Women: Data Bias in a World Designed for Men by Caroline Criado Pérez</a></li>
          <li><a href="https://www.goodreads.com/book/show/44453636-data-feminism">Data Feminism by Catherine D’Ignazio and Lauren F. Klein</a></li>
        </ol>

        <h4>📚 Previous Reads</h4>
        <ol>
          <li><a href="https://www.goodreads.com/book/show/14572.Peace_Is_Every_Step">Peace Is Every Step by Thich Nhat Hanh</a></li>
          <li><a href="https://www.goodreads.com/book/show/18003300-love-misadventure">Love & Misadventure by Lang Leav ❤️</a></li>
          <li><a href="https://www.goodreads.com/book/show/22151696-lullabies">Lullabies by Lang Leav</a></li>
          <li><a href="https://www.goodreads.com/book/show/22245334-the-utopia-of-rules">The Utopia of Rules: On Technology, Stupidity, and the Secret Joys of Bureaucracy by David Graeber</a></li>
          <li><a href="https://aiethics.princeton.edu/case-studies/case-study-pdfs/">Case Studies by Princeton University</a></li>
          <li><a href="https://www.google.com/books/edition/Ethics_and_Data_Science/UXHKDwAAQBAJ?hl=en&gbpv=1&dq=eTHICS+AND+DATA+SCIENCE&printsec=frontcover">Ethics and Data Science by DJ Patil, Hilary Mason, and Mike Loukides</a></li>
        </ol>`
      }
    ],
    "copyright":{
      "year": "2022",
      "copyLink": "<a href='https://www.odu.edu/directory/neha-niphadkar'>Neha N</a>"
    }
  }
};
